import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';

export class TokenCaptureUtils {
  
  static captureAndStoreTokens(): boolean {
    const urlParams = new URLSearchParams(globalThis.location.search);
    
    const SSID = urlParams.get(CONFIG.AUTH.SSID);
    const usr_id = urlParams.get(CONFIG.AUTH.USER_ID);
    
    if (SSID || usr_id) {
      
      const cookieOptions = {
        expires: 7,
        domain: CONFIG.getCookieDomain(),
        path: '/',
        secure: globalThis.location.protocol === 'https:',
        sameSite: 'lax' as const
      };

      if (SSID) {
        Cookies.set(CONFIG.AUTH.SSID , SSID, cookieOptions);
      }
      
      if (usr_id) {
        Cookies.set(CONFIG.AUTH.USER_ID, usr_id, cookieOptions);
      }
      
      const url = new URL(globalThis.location.href);
      url.searchParams.delete(CONFIG.AUTH.SSID);
      url.searchParams.delete(CONFIG.AUTH.USER_ID);
      globalThis.history.replaceState({}, document.title, url.toString());
      
      return true;
    }
    
    return false;
  }
}